import { Helmet } from 'react-helmet-async'
import { useLocale } from '@/i18n/locale'
import interCyrillic from '@fontsource-variable/inter/files/inter-cyrillic-wght-normal.woff2?url'
import interLatin from '@fontsource-variable/inter/files/inter-latin-wght-normal.woff2?url'
import playfairCyrillic from '@fontsource-variable/playfair-display/files/playfair-display-cyrillic-wght-normal.woff2?url'
import playfairLatin from '@fontsource-variable/playfair-display/files/playfair-display-latin-wght-normal.woff2?url'

/**
 * Предзагрузка шрифтов первого экрана: кириллица и латиница Inter (текст) и
 * один файл Playfair Display (заголовки, решение Тони 2026-09-26) — тот,
 * которым набран H1 этой локали: кириллица на русских страницах, латиница на
 * английских. Без предзагрузки браузер узнаёт о шрифте только после разбора
 * CSS и первого текста, и первый экран успевает отрисоваться запасным.
 * Остальные подмножества, курсив и моноширинный грузятся по требованию.
 */
export function FontPreload() {
  const heading = useLocale() === 'en' ? playfairLatin : playfairCyrillic
  return (
    <Helmet>
      <link rel="preload" as="font" type="font/woff2" href={interCyrillic} crossOrigin="anonymous" />
      <link rel="preload" as="font" type="font/woff2" href={interLatin} crossOrigin="anonymous" />
      <link rel="preload" as="font" type="font/woff2" href={heading} crossOrigin="anonymous" />
    </Helmet>
  )
}
